import { render } from "./MarketFlowView.vue?vue&type=template&id=043ed97a&scoped=true"
import script from "./MarketFlowView.vue?vue&type=script&lang=js"
export * from "./MarketFlowView.vue?vue&type=script&lang=js"

import "./MarketFlowView.vue?vue&type=style&index=0&id=043ed97a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-043ed97a"]])

export default __exports__